/* Pagina de produs cu plata ramburs (COD) */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var OPTION_SELECTOR = '.cod__swatch, .cod__pack';

  /* === ENDPOINT COMANDA DIRECTA ===
     Aici se trimite comanda. Inlocuieste cu URL-ul tau de pe Vercel.
     Se poate suprascrie si din theme.liquid cu:
       <script>window.COD_ORDER_ENDPOINT = 'https://...';</script>   */
  var ORDER_ENDPOINT =
    window.COD_ORDER_ENDPOINT || 'https://comanda-directa.vercel.app/api/comanda';

  /* Pagina pe care ajunge clientul dupa ce comanda a fost inregistrata. */
  var THANK_YOU_PATH = '/pages/multumim';

  function initBadgeCarousel(root) {
    var box = root.querySelector('[data-badge-carousel]');
    if (!box) return;
    var track = box.querySelector('.cod__badges-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2 || reduced) return;

    var itemH = 0;
    var idx = 0;
    var timer = null;
    var delay = (parseFloat(box.dataset.speed) || 3) * 1000;

    track.appendChild(slides[0].cloneNode(true));

    function measure() {
      itemH = slides[0].getBoundingClientRect().height;
      if (!itemH) return;
      box.style.height = itemH + 'px';
      track.style.transition = 'none';
      track.style.transform = 'translateY(' + (-idx * itemH) + 'px)';
    }

    function step() {
      if (!itemH) measure();
      if (!itemH) return;
      idx++;
      track.style.transition = 'transform .55s cubic-bezier(.4, 0, .2, 1)';
      track.style.transform = 'translateY(' + (-idx * itemH) + 'px)';
      if (idx >= slides.length) {
        setTimeout(function () {
          idx = 0;
          track.style.transition = 'none';
          track.style.transform = 'translateY(0px)';
        }, 570);
      }
    }

    function start() { stop(); timer = setInterval(step, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(box.parentElement || box);
    window.addEventListener('resize', measure);

    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    start();
  }

  function init(root) {
    var sectionId = root.dataset.sectionId;
    var modal = document.getElementById('codm-' + sectionId);
    var cfgEl = document.getElementById('cod-config-' + sectionId);

    initBadgeCarousel(root);

    if (!modal || !cfgEl) return;

    var cfg = JSON.parse(cfgEl.textContent);
    var moneyFormat = cfg.moneyFormat;
    var shipping = cfg.shipping;
    var freeFrom = cfg.freeFrom;
    var variants = cfg.variants;
    var optionCount = cfg.optionCount;
    var current = cfg.current;
    var au = cfg.autoUpgrade || {};

    /* Tracking TikTok: gestionat de aplicatia oficiala TikTok din Shopify.
       Codul manual a fost scos ca sa nu se numere evenimentele de doua ori.
       Evenimentul de achizitie se trimite acum server-side, din endpointul
       de comanda, plus o data din pagina de multumire (deduplicat prin event_id). */

    function money(cents) {
      var s = (cents / 100).toFixed(2).replace('.', ',');
      var whole = String(Math.round(cents / 100));
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, s)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount\s*\}\}/g, s);
    }

    var mainImg = root.querySelector('#cod-main-img');
    root.querySelectorAll('.cod__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.dataset.full;
        root.querySelectorAll('.cod__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    var selected = [];
    for (var i = 0; i < optionCount; i++) {
      var active = root.querySelector('.is-active[data-option-index="' + i + '"]');
      selected[i] = active ? active.dataset.value : (current.options ? current.options[i] : null);
    }

    function syncVariant() {
      var match = variants.filter(function (vr) {
        for (var k = 0; k < optionCount; k++) { if (vr.options[k] !== selected[k]) return false; }
        return true;
      })[0];
      if (!match) return;
      current = match;
      var priceEl = root.querySelector('#cod-price');
      var compareEl = root.querySelector('#cod-compare');
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      renderSummary();
    }

    root.querySelectorAll(OPTION_SELECTOR).forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = parseInt(b.dataset.optionIndex, 10);
        selected[idx] = b.dataset.value;
        root.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (x) {
          x.classList.remove('is-active');
          if (x.hasAttribute('aria-checked')) x.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        if (b.hasAttribute('aria-checked')) b.setAttribute('aria-checked', 'true');
        var lbl = root.querySelector('#cod-opt-val-' + idx);
        if (lbl) lbl.textContent = b.dataset.value.toUpperCase();
        syncVariant();
      });
    });

    /* ---- cantitate (optionala: poate lipsi cand se vinde pe pachete) ---- */
    var qtyInput = root.querySelector('#cod-qty');
    function qty() {
      if (!qtyInput) return 1;
      var n = parseInt(qtyInput.value, 10);
      return (isNaN(n) || n < 1) ? 1 : n;
    }

    var noteEl = root.querySelector('#cod-upgrade-note');
    var noteTxt = root.querySelector('#cod-upgrade-text');
    var noteTimer = null;

    function packByValue(val) {
      var found = null;
      root.querySelectorAll('.cod__pack').forEach(function (p) {
        if (p.dataset.value === val) found = p;
      });
      return found;
    }

    function showNote(text) {
      if (!noteEl || !noteTxt || !text) return;
      noteTxt.textContent = text;
      noteEl.hidden = false;
      if (noteTimer) clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { noteEl.hidden = true; }, 9000);
    }

    function maybeAutoUpgrade(nextQty) {
      if (!au.enabled || !au.to) return nextQty;
      var trigger = parseInt(au.qty, 10) || 2;
      if (nextQty < trigger) return nextQty;
      if (selected[0] === au.to) return nextQty;
      var target = packByValue(au.to);
      if (!target) return nextQty;

      target.click();
      target.classList.add('just-upgraded');
      setTimeout(function () { target.classList.remove('just-upgraded'); }, 950);
      showNote(au.note);
      try { target.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' }); } catch (e) {}
      return 1;
    }

    if (qtyInput) {
      root.querySelectorAll('.cod__qty-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = Math.max(1, qty() + parseInt(b.dataset.step, 10));
          next = maybeAutoUpgrade(next);
          qtyInput.value = next;
          renderSummary();
        });
      });
      qtyInput.addEventListener('input', renderSummary);
      qtyInput.addEventListener('change', function () {
        qtyInput.value = maybeAutoUpgrade(qty());
        renderSummary();
      });
    }

    var summaryEl = modal.querySelector('#codm-summary');
    function upsells() {
      return Array.prototype.slice.call(modal.querySelectorAll('.codm__upsell-cb:checked')).map(function (cb) {
        return { id: cb.dataset.variant, price: parseInt(cb.dataset.price, 10), title: cb.dataset.title };
      });
    }
    function renderSummary() {
      var sub = current.price * qty();
      var ship = (freeFrom > 0 && sub >= freeFrom) ? 0 : shipping;
      var label = qty() > 1 ? current.title + ' &times; ' + qty() : current.title;
      var rows = '<div class="codm__line"><span>' + label + '</span><b>' + money(sub) + '</b></div>';
      rows += '<div class="codm__line"><span>Livrare</span><b>' + (ship === 0 ? 'GRATUITA' : money(ship)) + '</b></div>';
      var total = sub + ship;
      upsells().forEach(function (u) {
        total += u.price;
        rows += '<div class="codm__line"><span>' + u.title + '</span><b>' + money(u.price) + '</b></div>';
      });
      rows += '<div class="codm__line codm__line--total"><span>Total</span><span>' + money(total) + '</span></div>';
      summaryEl.innerHTML = rows;
    }
    modal.querySelectorAll('.codm__upsell-cb').forEach(function (cb) { cb.addEventListener('change', renderSummary); });

    function open() {
      modal.hidden = false;
      document.body.classList.add('codm-open');
      renderSummary();
    }
    function close() { modal.hidden = true; document.body.classList.remove('codm-open'); }
    root.querySelector('#cod-open').addEventListener('click', open);
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    var form = modal.querySelector('form');
    var errEl = modal.querySelector('#codm-err');
    var submitBtn = modal.querySelector('#codm-submit');
    var submitLabel = submitBtn ? submitBtn.textContent : '';

    /* Capcana pentru boti: campul e invizibil, un om nu-l completeaza niciodata.
       Daca vine completat, serverul arunca comanda in gol. */
    var hp = document.createElement('input');
    hp.type = 'text';
    hp.name = 'website';
    hp.tabIndex = -1;
    hp.autocomplete = 'off';
    hp.setAttribute('aria-hidden', 'true');
    hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;';
    form.appendChild(hp);

    var sending = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;

      if (sending) return; // dublu-click pe buton

      var data = {
        name: form.name.value.trim(),
        phone: form.phone.value.trim(),
        email: form.email.value.trim(),
        address: form.address.value.trim(),
        judet: form.judet.value,
        city: form.city.value.trim()
      };

      if (!data.name || !data.phone || !data.address || !data.judet || !data.city) {
        errEl.textContent = 'Te rugam sa completezi toate campurile marcate cu *.';
        errEl.hidden = false;
        return;
      }
      if (data.phone.replace(/[^0-9]/g, '').length < 9) {
        errEl.textContent = 'Numarul de telefon nu pare valid.';
        errEl.hidden = false;
        return;
      }

      sending = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Se trimite...';

      /* Trimitem doar ID-urile si cantitatile. Preturile se recalculeaza
         pe server din Shopify, ca sa nu le poata modifica nimeni din browser. */
      var items = [{ variantId: current.id, quantity: qty() }];
      upsells().forEach(function (u) {
        items.push({ variantId: parseInt(u.id, 10), quantity: 1 });
      });

      /* Continutul comenzii pentru evenimentul TikTok de pe pagina de multumire. */
      var contents = [{
        content_id: String(current.id),
        content_type: 'product',
        content_name: current.title,
        quantity: qty(),
        price: current.price / 100
      }];
      upsells().forEach(function (u) {
        contents.push({
          content_id: String(u.id),
          content_type: 'product',
          content_name: u.title,
          quantity: 1,
          price: u.price / 100
        });
      });

      fetch(ORDER_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: data.name,
          phone: data.phone,
          email: data.email,
          address: data.address,
          judet: data.judet,
          city: data.city,
          packTitle: current.title,
          items: items,
          hp: hp.value
        })
      })
        .then(function (r) {
          return r.json().then(function (body) { return { ok: r.ok, body: body }; });
        })
        .then(function (res) {
          if (!res.ok || !res.body.ok) {
            throw new Error(res.body && res.body.error ? res.body.error : 'Comanda nu a putut fi inregistrata.');
          }

          /* Telefonul si emailul merg prin sessionStorage, NU prin URL:
             sunt date personale si n-au ce cauta in bara de adresa, in
             istoric sau in referrer. Pagina de multumire le citeste, le
             transforma in hash SHA-256 si le sterge imediat. */
          try {
            sessionStorage.setItem('cod_match', JSON.stringify({
              phone: data.phone,
              email: data.email,
              contents: contents
            }));
          } catch (e) { /* mod incognito - mergem mai departe fara matching */ }

          var q = '?comanda=' + encodeURIComponent(res.body.order) +
                  '&total=' + encodeURIComponent(res.body.total || '') +
                  '&ev=' + encodeURIComponent(res.body.eventId || '');
          window.location.href = THANK_YOU_PATH + q;
        })
        .catch(function (err) {
          sending = false;
          submitBtn.disabled = false;
          submitBtn.textContent = submitLabel;
          errEl.textContent = err && err.message
            ? err.message
            : 'A aparut o eroare. Te rugam sa incerci din nou.';
          errEl.hidden = false;
        });
    });

    renderSummary();
  }

  function boot() {
    document.querySelectorAll('.cod[data-section-id]').forEach(function (el) {
      if (el.dataset.codReady) return;
      el.dataset.codReady = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
